/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # Forms utils
define('global/Forms',[
    'jquery',
    'lodash',
    './Logger',
    './Constants'
], function ($, _, Logger, Constants) {
    'use strict';

    // Updated objects using path like Address.Id ect
    function updateObject(object, newValue, path) {
        var stack = path.split('.');
        while (stack.length > 1) {
            object = object[stack.shift()];
        }
        object[stack.shift()] = newValue;
    }

    function getObjectById(id, collection) {
        var obj = _.filter(collection, function (f) {
            return f.id === id;
        });

        if (obj.length > 0) {
            return obj[0];
        } else {
            return null;
        }
    }

    function deepValue(obj, path) {
        var splitPath = path.split('.');
        for (var i = 0, len = splitPath.length; i < len; i++) {
            try {
                obj = obj[splitPath[i]];
            } catch (e) {
                return null;
            } 
        };
        return obj;
    };

    function clearFormInputs(sel) {
        $(sel + ' input[type="text"],  ' + sel + ' input[type="search"],  ' + sel + ' input[type="email"], ' +
          sel + ' input[type="url"],  ' + sel + ' input[type="tel"],  ' + sel + ' input[type="number"], ' +
          sel + ' input[type="range"],  ' + sel + ' input[type="date"],  ' + sel + ' input[type="month"], ' +
          sel + ' input[type="week"],  ' + sel + ' input[type="time"],  ' + sel + ' input[type="datetime"],' +
          sel + ' input[type="datetime-local"],  ' + sel + ' input[type="color"], ' +
          sel + ' input[type="password"],  ' + sel + ' input[type="file"], ' +
          sel + ' textarea,' + sel + ' select').val('').trigger(Constants.events.general.CHANGE);
    };

    function populateData(data, form) {
        _.forEach(form.Fields, function(n) {
            if(n.Type === 'Checkbox') {
                var value = deepValue(data, n.Param);
                if (value === true) {
                    $(n.Field).prop('checked', true);
                } else {
                    $(n.Field).prop('checked', false);
                }
            } else {
                $(n.Field).val(deepValue(data, n.Param)).trigger(Constants.events.general.CHANGE);
            }
        });
    }

    function clearData(form, enableFields) {
        var enableFormFields = enableFields || false;

        _.forEach(form.Fields, function (n) {
            var defaultValue = (typeof n.DefaultValue !== 'undefined') ? n.DefaultValue : '';
            var $field = $(n.Field);
            $field.val(defaultValue).trigger(Constants.events.general.CHANGE);
            if (enableFormFields) {
                $field.prop('disabled', false);
            }
        });
    }

    function loadDetails(id, form, collection) {
        var entityToEdit = getObjectById(id, collection);
        populateData(entityToEdit, form);
    };
    
    function getFormValues(form, $container) {
        var data = {};
        _.forEach(form.Fields, function (n, k) {
            var propertyName = n.Param.split('.')[n.Param.split('.').length - 1];
            if (typeof n.GetValueMethod !== 'undefined') {
                var param = n.GetValueMethod.Param ? $(n.GetValueMethod.Param).val() : null;
                //var fnGetValue = deepValue(window, n.GetValueMethod.Name);
                var fnGetValue = n.GetValueMethod.fn;
                if (typeof fnGetValue === 'function') {
                    data[propertyName] = fnGetValue(param);
                    if (n.Field) {
                        if ($container) {
                            $container.find(n.Field).val(data[propertyName]);
                        } else {
                            $(n.Field).val(data[propertyName]);
                        }
                    }
                } else {
                    console.warn('fn: ' + n.GetValueMethod.fn + ' not found');
                }
            } else {
                var $field = $container ? $container.find(n.Field) : $(n.Field);
                var value = n.Type === 'Checkbox' ? $field.is(':checked') : $field.val();
                if (typeof n.ExcluedIfEmpty !== 'undefined' && n.ExcluedIfEmpty === true && value === '') {
                    return;
                }
                data[propertyName] = value;
            }
        });
        return data;
    }

    var Forms = {
        populateData: populateData,
        loadDetails: loadDetails,
        getFormValues: getFormValues,
        clearFormInputs: clearFormInputs,
        clearData: clearData
    };

    Logger.debug('Forms.js Loaded', Forms);

    return Forms;
});
